(() => {
  const root = document.querySelector('cart-drawer.cp-owned-cart');
  if (!root) return;
  let frame = 0;
  const fit = () => {
    frame = 0;
    if (!root.classList.contains('active')) return;
    root.querySelectorAll('.cp-owned-cart-recommendations__list').forEach(list => {
      const width = list.clientWidth;
      if (!width || !list.children.length) return;
      const position = list.scrollLeft / width;
      const first = Math.max(0, Math.min(list.children.length - 1, Math.floor(position)));
      const last = Math.max(0, Math.min(list.children.length - 1, Math.ceil(position)));
      const height = Math.ceil(Math.max(list.children[first].getBoundingClientRect().height, list.children[last].getBoundingClientRect().height));
      if (height) list.style.height = height + 'px';
    });
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(fit); };
  new MutationObserver(schedule).observe(root, { childList: true, subtree: true, characterData: true });
  root.addEventListener('scroll', event => {
    if (event.target.matches('.cp-owned-cart-recommendations__list')) schedule();
  }, true);
  root.addEventListener('change', schedule);
  root.addEventListener('load', schedule, true);
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('cp:cart:opened', schedule);
})();
